module.exports = __webpack_public_path__ + "static/media/Portrait-10238.93de3417.jpg";